export default __webpack_public_path__ + "08b8ed7965012174e9e3b3022e0214c0.svg";